import { Box } from '@mui/material';
import React, { useMemo } from 'react';
import { isValidUrl } from 'utils/media';

interface ThumbnailViewProps {
  fullImageUrl: string;
  rowView?: boolean;
  placeholder?: boolean;
  fullVideoUrl?: string;
  imageStyle?: React.CSSProperties;
}

export const ThumbnailView = ({
  fullImageUrl,
  rowView = false,
  placeholder = false,
  fullVideoUrl = '',
  imageStyle,
}: ThumbnailViewProps) => {
  const isValidVideo = useMemo(() => isValidUrl(fullVideoUrl), [fullVideoUrl]);
  return (
    <Box sx={{ display: 'flex', alignItems: 'start' }}>
      {fullVideoUrl && isValidVideo ? (
        // eslint-disable-next-line jsx-a11y/media-has-caption
        <video controls style={{ width: 'auto', maxHeight: '45vh', minHeight: '100px' }}>
          <source src={fullVideoUrl} type="video/mp4" />
          <source src={fullVideoUrl} type="video/webm" />
          <source src={fullVideoUrl} type="video/ogg" />
          Your browser does not support the video tag.
        </video>
      ) : fullImageUrl ? (
        <img
          src={fullImageUrl}
          alt={''}
          style={{ maxWidth: rowView ? '50%' : '100%', ...imageStyle }}
        />
      ) : placeholder ? (
        <img
          src="/img/placeholder-image.png"
          alt={''}
          style={{ maxWidth: rowView ? '15%' : '50%' }}
        />
      ) : null}
    </Box>
  );
};
